/**
 * UpgradeRequiredScreen — rendered when the backend returns 426 on
 * /device/config. All background loops are already paused by the
 * controller at this point.
 *
 * Spec: signage-web-player-spec §9.
 */

import { DeviceController } from '../state/controller.js';

export function renderUpgrade(root: HTMLElement, controller: DeviceController): void {
  root.innerHTML = '';
  root.className = 'ag-app ag-upgrade';

  const icon = document.createElement('div');
  icon.className = 'ag-upgrade__icon';
  icon.textContent = '⚠';
  root.appendChild(icon);

  const title = document.createElement('h1');
  title.className = 'ag-upgrade__title';
  title.textContent = 'Update required';
  root.appendChild(title);

  const sub = document.createElement('p');
  sub.className = 'ag-upgrade__sub';
  const min = controller.upgradeInfo?.minimumVersion;
  sub.textContent = min
    ? `This display needs at least version ${min}. Reloading will fetch the latest version.`
    : 'This display needs to refresh. Reloading will fetch the latest version.';
  root.appendChild(sub);

  const btn = document.createElement('button');
  btn.className = 'ag-upgrade__btn';
  btn.type = 'button';
  btn.textContent = 'Reload now';
  btn.addEventListener('click', () => {
    try {
      window.location.reload();
    } catch {
      /* jsdom / non-browser: swallow */
    }
  });
  root.appendChild(btn);

  queueMicrotask(() => btn.focus());
}
